// ห้ามลบ: import นี้ตั้ง window.Prism ตั้งแต่เปิดแอป (SonarQube S1128 อาจมองว่า unused)
// prism-clike.js / prism-javascript.js อ้าง global Prism โดยไม่ import core เอง ถ้าไม่มีบรรทัดนี้
// หน้า LLMManagement จะขึ้น ReferenceError: Prism is not defined (QA #193)
import 'prismjs';
import './assets/main.css'
import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router';
import FlagIcon from 'vue-flag-icon';
import axios from 'axios';
import store from "./store";
import i18n, { i18nPlugin } from './plugins/i18n';
import dateUtils from '@/plugins/date-utils';
import { displayDocName, displayDocNames, docItemTitle } from '@/utils/docName';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import APICall from '@/api/call';
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import {version} from "./../package.json";
import $ from 'jquery';

const app = createApp(App);

// สำคัญ: ต้องใช้งาน Vuetify ก่อน plugins อื่นๆ
app.use(vuetify)
// จากนั้นค่อยใช้ plugins อื่นๆ
app.use(FlagIcon);
// heightAuto: false — ค่าเริ่มต้นของ SweetAlert2 ใส่ height:auto ให้ html/body ตอน popup เปิด ทำให้ v-main (ตัวที่ scroll จริงของแอป)
// เสียความสูงแล้ว scroll กลับไปบนสุดทุกครั้งที่มี popup — ปิดไว้ให้หน้าอยู่ตำแหน่งเดิม (popup เป็น fixed overlay อยู่แล้ว)
app.use(VueSweetalert2, { heightAuto: false });
app.use(APICall);
app.use(i18nPlugin);
app.use(i18n);
app.use(store);
app.use(router);

// ตั้งค่า global properties
app.config.globalProperties.$http = axios;
app.config.globalProperties.$http.defaults.withCredentials = true;
app.config.globalProperties.$http.defaults.timeout = 500000;
globalThis.$ = globalThis.jQuery = $;
app.config.productionTip = false;

// กำหนดค่าโกลบอล
app.config.globalProperties.$dateUtils = dateUtils;
app.config.globalProperties.$version = version;
// ชื่อเอกสารสำหรับแสดงผล (ซ่อนส่วนต่อท้ายที่ระบบสุ่ม) — ใช้กับข้อความที่แสดงเท่านั้น ห้ามใช้กับค่าที่ส่ง API (utils/docName.js)
app.config.globalProperties.$docName = displayDocName;
app.config.globalProperties.$docNames = displayDocNames;
app.config.globalProperties.$docItemTitle = docItemTitle;

// import static files
import('@/assets/styles/table.css');
import('@/assets/styles/popup.css');
import('@/assets/styles/globals.css');

// DGA Design System — token layer (CSS custom properties on :root)
import '@/components/ds/tokens/dga-tokens.scss';

// กำหนดข้อมูลโกลบอล
app.provide('SetPopup', false);
app.provide('IsAllowImage', false);
app.provide('overlay', false);

// Mount app
app.mount('#app');

